import { useEffect } from 'react';
import {
  useStoreActions,
  useStoreRehydrated,
  useStoreState,
} from '@discover-data/stores/restaurant/hooks';
import useCitySlug from '@discover-data/stores/hooks/useCitySlug';
import usePage from '@discover-data/stores/hooks/page/usePage';

/**
 * Sync the resolved suburb router state to the restaurant store.
 * useCitySlug handles all URL parsing and prioritisation (query params > slug).
 */
export default function useSyncSuburb() {
  const rehydrated = useStoreRehydrated();
  const [{ suburbs }] = useCitySlug();
  const storeIds = useStoreState((state) => state.suburb.ids);
  const setStoreIds = useStoreActions((actions) => actions.suburb.set);

  const resetAllIds = useStoreActions((actions) => actions.allIds.reset);
  const { resetPage } = usePage();

  const resolvedIdKey = suburbs.map((suburb) => suburb.id).join();

  useEffect(() => {
    if (!rehydrated) {
      return;
    }

    const storeIdKey = storeIds.join();
    if (resolvedIdKey !== storeIdKey) {
      resetPage();
      // reset the restaurants when navigating to a new suburb (e.g. via the suburb link on the restaurant card)
      resetAllIds();
      setStoreIds(suburbs.map(({ id }) => id));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rehydrated, resolvedIdKey]);
}
